module.exports = __webpack_public_path__ + "static/media/template.2ab0d577.svg";